import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './lib/i18n';
import AuthProvider from './contexts/AuthProvider';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Overview from './pages/Overview';
import MenuAnalysis from './pages/MenuAnalysis';
import Traffic from './pages/Traffic';
import Products from './pages/Products';
import Mapping from './pages/Mapping';
import Receipts from './pages/Receipts';
import Composition from './pages/Composition';
import Relations from './pages/Relations';
import Reports from './pages/Reports';
import DataStatus from './pages/DataStatus';
import Packaging from './pages/Packaging';

/**
 * Perfy · Calum — café analytics dashboard.
 * Prestaties (Overzicht · Drukte & Tijden · Kassabonnen), Producten, Beheer.
 * Old URLs (/rapport, /catalog) redirect to the pages that absorbed them.
 */
const protect = (el) => <PrivateRoute>{el}</PrivateRoute>;

function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/overview" element={protect(<Overview />)} />
          <Route path="/rapport" element={<Navigate to="/overview" replace />} />
          <Route path="/menu" element={protect(<MenuAnalysis />)} />
          <Route path="/traffic" element={protect(<Traffic />)} />
          <Route path="/products" element={protect(<Products />)} />
          <Route path="/catalog" element={<Navigate to="/products" replace />} />
          <Route path="/mapping" element={protect(<Mapping />)} />
          <Route path="/receipts" element={protect(<Receipts />)} />
          <Route path="/composition" element={protect(<Composition />)} />
          <Route path="/relations" element={protect(<Relations />)} />
          <Route path="/packaging" element={protect(<Packaging />)} />
          <Route path="/reports" element={protect(<Reports />)} />
          <Route path="/data" element={protect(<DataStatus />)} />
          <Route path="/dashboard" element={<Navigate to="/overview" replace />} />
          <Route path="/" element={<Navigate to="/overview" replace />} />
          <Route path="*" element={<Navigate to="/overview" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
